import { ApiService } from 'services';
import { toastr } from 'react-redux-toastr';

import { handleException } from 'actions/exceptions';

export const EDIT_CUSTOMER = 'EDIT_CUSTOMER';
export const EDIT_CUSTOMER_CANCEL = 'EDIT_CUSTOMER_CANCEL';
export const UPDATE_CUSTOMER_REQUEST = 'UPDATE_CUSTOMER_REQUEST';
export const UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS';
export const UPDATE_CUSTOMER_ERROR = 'UPDATE_CUSTOMER_ERROR';

function edit() {
  return {
    type: EDIT_CUSTOMER
  };
}

function cancelEdit() {
  return {
    type: EDIT_CUSTOMER_CANCEL
  };
}

function request() {
  return {
    type: UPDATE_CUSTOMER_REQUEST
  };
}

function receive(emailAddress) {
  return {
    type: UPDATE_CUSTOMER_SUCCESS,
    emailAddress
  };
}

function reject() {
  return {
    type: UPDATE_CUSTOMER_ERROR
  };
}

export function editCustomer() {
  return (dispatch) => {
    dispatch(edit());
  };
}

export function cancelEditCustomer() {
  return (dispatch) => {
    dispatch(cancelEdit());
  };
}

export function updateCustomer(customerId, emailAddress) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .updateCustomer(customerId, emailAddress)
      .then(() => {
        dispatch(receive(emailAddress));
        toastr.success('Success', 'Email address updated successfully');
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
